import React, { createContext, useMemo, useReducer } from "react";
import { _O } from "../modules/utils";
import {
  allDelCookies,
  clearAuth,
  getCookie,
  setAuth,
  setCookie,
  setCookieWs,
  setCookies,
} from "../modules/utils/cookie";
import { closeLoadingLayer } from "../views/common/Layer/Loading";
import { openAlertPopup } from "../views/Layout";
import { webRequest } from "../views/Nftf/Interface/NFTF/NativeApi";

// 운영서버
export const SERVER_TARGET = "LIVE";

// 검증서버
// export const SERVER_TARGET = "STAGE";

// 개발서버
// const SERVER_TARGET = "DEV";
const userinfoInProps = {
  userName: "",
  userToken: "",
  phoneToken: "",
  userPhone: "",
  userEmail: "",
  birth: "",
  sex: "",
};

// 인터페이스 URL
// Web URL : 본인인증 용도
// Fax URL
// Mail URL
const cfgInProps =
  SERVER_TARGET === "LIVE"
    ? {
        // 운영
        url: "https://app.mdpeople.co.kr/interface/",
        webUrl: "https://mdpeople.co.kr/",
        faxUrl: "https://www.mdpeople.co.kr/",
        mailUrl: "https://www.mdpeople.co.kr/",
        videoUrl: "https://app.mdpeople.co.kr/",
        nftfReturnUrl: "/#/common/loading/",
        nftfServerUrl: "https://nftf.mdpeople.co.kr/",

        // WebSocket URL
        webSocketUrl: "ws://localhost:11004",
      }
    : SERVER_TARGET === "STAGE"
    ? {
        // 검증
        url: "https://stage.mdpeople.co.kr/inter/interface/",
        webUrl: "https://stage.mdpeople.co.kr/server/",
        faxUrl: "https://stage.mdpeople.co.kr/server/",
        mailUrl: "https://stage.mdpeople.co.kr/server/",
        videoUrl: "http://115.85.182.235/inter/",
        nftfReturnUrl: "/#/common/loading/",
        nftfServerUrl: "https://stage.mdpeople.co.kr:3333/",

        // WebSocket URL
        webSocketUrl: "ws://localhost:11004",
      }
    : {
        // 개발
        url: "https://dev.mdpeople.co.kr/inter/interface/",
        webUrl: "https://dev.mdpeople.co.kr/",
        faxUrl: "https://dev.mdpeople.co.kr/",
        mailUrl: "https://dev.mdpeople.co.kr/",
        nftfReturnUrl: "/pado/#/common/loading/",
        nftfServerUrl: "https://dev.mdpeople.co.kr:3333/",

        // WebSocket URL
        webSocketUrl: "ws://localhost:11004",
      };

export const paymentCfg =
  SERVER_TARGET === "LIVE"
    ? {
        // 운영
        url: "https://pgapi.easypay.co.kr/api/trades/webpay",
        rtnUrl: cfgInProps.webUrl + "payment/?userToken=",
        rtnUIUrl: "pmr/proof/result/",
        mallId: "05560685",
        batchMallId: "05571880",
      }
    : SERVER_TARGET === "STAGE"
    ? {
        // 검증
        url: "https://testpgapi.easypay.co.kr/api/trades/webpay",
        rtnUrl: cfgInProps.webUrl + "payment/?userToken=",
        rtnUIUrl: "pmr/proof/result/",
        mallId: "T0010932",
        batchMallId: "T0010932",
      }
    : {
        // 개발
        url: "https://testpgapi.easypay.co.kr/api/trades/webpay",
        rtnUrl: cfgInProps.webUrl + "payment/?userToken=",
        rtnUIUrl: "pmr/proof/result/",
        mallId: "T0010932",
        batchMallId: "T0010932",
      };

const authCfg = {
  Naver_Client_Id: "dt5zatby5w",
  Naver_Client_Key: "D9rjsSNeH7defRgEezi0ZfzKZUK3eqoc9emGZ7fL",
};

export const defaultBs = {
  afMaxBs: 180,
  afMinBs: 120,
  bfMaxBs: 120,
  bfMinBs: 80,
};

// WebSocket 작업 [[
export const SocketCommand = {
  GET_PHONE_INFO: { command: "100", data: "" },
  GET_PHONE_INFO_RES: "100",
  GET_PHONE_INFO_OLD: "getPhoneInfo",

  // GPS 정보 받아오기\
  GET_GPS_INFO: { command: "101", data: { userLat: "", userLng: "" } },
  GET_GPS_INFO_RES: "101",

  UPDATE_PHONE_USER_INFO: {
    command: "wn200",
    data: { login: "", userToken: "" },
  },
  UPDATE_PHONE_USER_INFO_RES: "nw200",

  // 애플 아이디 로그인
  LOGIN_APPLE: { command: "wn201", data: {} },
  LOGIN_APPLE_RES: "nw201",

  // 파일 다운로드 & 조회
  COMMON_FILE_DOWNLOAD: { command: "wn300", data: {} },
  COMMON_FILE_DOWNLOAD_RES: "nw300",

  MULTI_FILE_DOWNLOAD: { command: "wn301", data: {} },
  MULTI_FILE_DOWNLOAD_RES: "nw301",

  // 파일 업로드
  FILE_UPLOAD: { command: "wn302", data: {} },
  FILE_UPLOAD_RES: "nw302",

  PROGRESS: { command: "wn501", data: {} },
  PROGRESS_RES: "nw501",

  COMMON_FILE_VIEW: { command: "wn310", data: "" },
  COMMON_FILE_VIEW_RES: "nw310",

  ETC_INPUT_DATA: { command: "wn320", data: "" },
  ETC_INPUT_DATA_RES: "nw320",

  // 외부 웹 브라우저
  WEB_VIEW_OPEN: { command: "wn400", data: "" },
  WEB_VIEW_OPEN_RES: "nw400",

  // 엠디에듀코
  MD_EDUCO_CONNECT: { command: "wn401", data: {} },
  MD_EDUCO_CONNECT_RES: "nw401",

  NATIVE_ACTION: { command: "wn500", data: {} },
  NATIVE_ACTION_RES: "nw500",

  // 쿠키셋팅
  SET_COOKIE: { command: "wn502", data: {} },
  SET_COOKIE_RES: "nw502",

  // 처방전 관련 웹소켓
  ADD_PAPER: { command: "wn600", data: {} },
  ADD_PAPER_RES: "nw600",

  PRSC_DNLD: { command: "wn601", data: {} },
  PRSC_DNLD_RES: "nw601",

  PRSC_DNLD_MULTI: { command: "wn610", data: {} },
  PRSC_DNLD_MULTI_RES: "nw610",

  GET_BT_STATUS: { command: "wn102", data: { sex: "", age: "", height: "" } },
  GET_BT_STATUS_RES: "nw102",

  BP170B_REGISTER: {
    command: "wn1000",
    data: { type: 0, modelName: "BP170B" },
  },
  BP170B_REGISTER_RES: "nw1000",

  BP170B_REMOVE: { command: "wn1001", data: { type: 0 } },
  BP170B_REMOVE_RES: "nw1001",

  BP170B_PAIRED_STATUS: { command: "wn1002", data: "" },
  BP170B_PAIRED_STATUS_RES: "wn1002",

  BP_CONNECT: { command: "wn1003", data: "" },
  BP_CONNECT_RES: "nw1003",

  BP_AUTOINPUT_STAUS: { command: "wn1004", data: { autoInput: false } },
  BP_AUTOINPUT_STAUS_RES: "nw1004",

  BP_MEASURE_DATA: { command: "wn1005", data: "" },
  BP_MEASURE_DATA_RES: "nw1005",

  BS_ACCUCHECK_REGISTER: {
    command: "wn2000",
    data: { type: 1, modelName: "ACCUCHECK" },
  },
  BS_ACCUCHECK_REGISTER_RES: "nw2000",
  BS_ACCUCHECK_REMOVE: { command: "wn2001", data: { type: 1 } },
  BS_ACCUCHECK_REMOVE_RES: "nw2001",
  BS_PAIRED_STATUS: { command: "wn2002", data: "" },
  BS_PAIRED_STATUS_RES: "nw2002",

  F62E_B_REGISTER: {
    command: "wn3000",
    data: { type: 2, modelName: "F62E_B" },
  },
  F62E_B_REGISTER_RES: "nw3000",
  F62E_B_REMOVE: { command: "wn3001", data: { type: 2 } },
  F62E_B_REMOVE_RES: "nw3001",
  F62E_B_MEASURE_DATA: { command: "wn3005", data: "" },
  F62E_B_MEASURE_DATA_RES: "nw3005",

  ETC_VIEW_OPEN_RES: "nw320",
  ETC_VIEW_OPEN: {
    command: "wn320",
    data: "",
  },
};
export let webSocket = new WebSocket(cfgInProps.webSocketUrl);
var callbackHandle;
var callback2Handle;

export const socketManager = (command, callback, putData, callback2) => {
  webRequest(command.command, putData);
};
// WebSocket 작업 ]]

export const checkMobile = () => {
  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

  if (varUA.indexOf("android") > -1) {
    //안드로이드
    return "ANDROID";
  } else if (
    varUA.indexOf("iphone") > -1 ||
    varUA.indexOf("ipad") > -1 ||
    varUA.indexOf("ipod") > -1
  ) {
    //IOS
    return "IOS";
  } else {
    //아이폰, 안드로이드 외
    return "WEB";
    // return "ANDROID";
  }
};

const phonecfgInProps = {
  phoneToken: "123",
  userLat: "37.4812544",
  userLng: "127.0426538",
  phoneOS: checkMobile(),
  version: "2.0.0",
};
const authInProps = false;

const mypagecfgInProps = {
  main: {
    BloodPressure: {
      cardNm: "MY 혈압",
      mndtYn: "N",
      sortNum: "2",
      cardYn: "N",
    },
    myHospitalList: {
      cardNm: "MY 진료기록",
      mndtYn: "N",
      sortNum: "1",
      cardYn: "N",
    },
    ReservationList: {
      cardNm: "MY 병원예약",
      mndtYn: "N",
      sortNum: "3",
      cardYn: "N",
    },
  },
  selfcard: {
    BP: {
      cardNm: "혈압",
      mndtYn: "Y",
      sortNum: "1",
      cardYn: "Y",
    },
    BMI: {
      cardNm: "BMI",
      mndtYn: "N",
      sortNum: "2",
      cardYn: "N",
    },
    BS: {
      cardNm: "혈당",
      mndtYn: "Y",
      sortNum: "3",
      cardYn: "Y",
    },
    HISTORY: {
      cardNm: "과거이력",
      mndtYn: "N",
      sortNum: "5",
      cardYn: "N",
    },
    FOOD: {
      cardNm: "식단",
      mndtYn: "N",
      sortNum: "6",
      cardYn: "N",
    },
    ACTIVE: {
      cardNm: "운동",
      mndtYn: "N",
      sortNum: "7",
      cardYn: "N",
    },
    BMI: {
      cardNm: "BMI",
      mndtYn: "N",
      sortNum: "4",
      cardYn: "N",
    },
    ALLERGY: {
      cardNm: "ALLERGY",
      mndtYn: "N",
      sortNum: "9",
      cardYn: "Y",
    },
    STUDYRESULT: {
      cardNm: "STUDYRESULT",
      mndtYn: "N",
      sortNum: "8",
      cardYn: "Y",
    },
  },
};

const deviceCfgInProps = {
  deviceTypes: [
    {
      index: 0,
      type: "bp",
      typeName: "혈압계",
      autoInput: false,
      devices: [
        {
          index: 0,
          deviceName: "BP170B",
          isConnected: false,
          autoInput: false,
          link: "/mp/settings/accessory/inbody",
        },
        {
          index: 1,
          deviceName: "OMRON",
          isConnected: false,
          autoInput: false,
          link: "/mp/settings/accessory/omron",
        },
      ],
    },
    {
      index: 1,
      type: "bs",
      typeName: "혈당계",
      autoInput: false,
      devices: [
        {
          index: 0,
          deviceName: "ACCU-CHEK Instant",
          isConnected: false,
          autoInput: false,
          link: "/mp/settings/accessory/accuCheck",
        },
        {
          index: 1,
          deviceName: "GluNEO Smart",
          isConnected: false,
          autoInput: false,
          link: "/mp/settings/accessory/glueNeo",
        },
      ],
    },
    {
      index: 2,
      type: "bmi",
      typeName: "체중계",
      autoInput: false,
      devices: [
        {
          index: 0,
          deviceName: "F62E-B",
          isConnected: false,
          autoInput: false,
          link: "/mp/settings/accessory/f62eb",
        },
        {
          index: 1,
          deviceName: "BP170B-c1",
          isConnected: false,
          autoInput: false,
          link: "",
        },
      ],
    },
  ],
};

const userHlthInfoProps = {
  hght: "",
  wght: "",
};

const uploadInfoProps = {
  userToken: "",
  hsptCd: "",
  trsmId: [],
  bizType: "",
  bizDtlType: "",
};
const pageStateProps = {
  share: 0,
  reload: 0,
};

const appStdInfoProps = {
  bpMax: 0,
  bpMin: 0,
  hrtRateMax: 0,
  hrtRateMin: 0,

  bsMax: 0,
  bsMin: 0,
};

const dvcBpInfoProps = [];
const dvcBsInfoProps = [];

const menuNewInfoProps = {
  // treatmentData: 1,
  // otherData: 0,
  // educationData: 1,
  // proofData: 0,
  phr01: "N",
  phr02: "N",
  phr03: "N",
  phr04: "N",
};

// dispatch using target
export const AppContext = createContext({
  dispatch: () => {},
  auth: false,
  userinfo: userinfoInProps,
  cfg: cfgInProps,
  mypagecfg: mypagecfgInProps,
  phonecfg: phonecfgInProps,
  deviceCfg: deviceCfgInProps,
  authCfg: authCfg,
  uploadInfo: uploadInfoProps,
  pageState: pageStateProps,
  appStdInfo: appStdInfoProps,
  dvcBpInfo: dvcBpInfoProps,
  dvcBsInfo: dvcBsInfoProps,
  menuNewInfo: menuNewInfoProps,
  prscList: [],
  acntMergeLayer: false,
  nftfDoctor: null,
  itemState: {
    data: null,
    reload: false,
  },
  nftfState: {
    data: null,
    reload: false,
  },
  idCardState: {
    data: null,
    reload: false,
  },
  mergeState: {
    data: null,
    reload: false,
  },
});

// dispatch initialState
export const initialState = {
  auth: false,
  userinfo: userinfoInProps,
  userHlthInfo: userHlthInfoProps,
  cfg: cfgInProps,
  mypagecfg: mypagecfgInProps,
  phonecfg: phonecfgInProps,
  loadMyInfoLoading: false, // 유저 정보 가져오기 시도중
  loadMyInfoDone: false,
  loadMyInfoError: null,
  loadUserLoading: false, // 유저 정보 가져오기 시도중
  loadUserDone: false,
  loadUserError: null,
  logInLoading: false, // 로그인 시도중
  logInDone: false,
  logInError: null,
  logOutLoading: false, // 로그아웃 시도중
  logOutDone: false,
  logOutError: null,
  signUpLoading: false, // 회원가입 시도중
  signUpDone: false,
  signUpError: null,

  deviceCfg: deviceCfgInProps, // device 정보

  authCfg: authCfg, // 외부 API 관련정보
  uploadInfo: uploadInfoProps,
  pageState: pageStateProps,

  appStdInfo: appStdInfoProps, // 데이터 서브밋 제한조건

  dvcBpInfo: dvcBpInfoProps, // 측정기기 혈압 리스트
  dvcBsInfo: dvcBsInfoProps, // 측정기기 혈당 리스트

  menuNewInfo: menuNewInfoProps, // 개인진료기록 새로운 자료 정보

  prscList: [],
  acntMergeLayer: false,
  nftfDoctor: null,
  itemState: {
    data: null,
    reload: false,
  },
  nftfState: {
    data: null,
    reload: false,
  },
  idCardState: {
    data: null,
    reload: false,
  },
  mergeState: {
    data: null,
    reload: false,
  },
};

export const LOAD_MY_INFO_REQUEST = "LOAD_MY_INFO_REQUEST";
export const LOAD_MY_INFO_SUCCESS = "LOAD_MY_INFO_SUCCESS";
export const LOAD_MY_INFO_FAILURE = "LOAD_MY_INFO_FAILURE";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAILURE = "LOAD_USER_FAILURE";

export const LOG_IN_REQUEST = "LOG_IN_REQUEST";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_FAILURE = "LOG_IN_FAILURE";

export const LOG_OUT_REQUEST = "LOG_OUT_REQUEST";
export const LOG_OUT_SUCCESS = "LOG_OUT_SUCCESS";
export const LOG_OUT_FAILURE = "LOG_OUT_FAILURE";

export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_FAILURE = "SIGN_UP_FAILURE";

export const SET_PHONETOKEN = "SET_PHONETOKEN";
export const SET_GPSINFO = "SET_GPSINFO";
export const SET_GPSINFO2 = "SET_GPSINFO2";
export const SET_PHONE_ALL = "SET_PHONE_ALL";

export const MAIN_MENU_SET = "MAIN_MENU_SET";
export const MAIN_MENU_ALL_SET = "MAIN_MENU_ALL_SET";
export const SELFCAED_MENU_SET = "SELFCAED_MENU_SET";
export const SELFCAED_MENU_ALL_SET = "SELFCAED_MENU_ALL_SET";
export const MENU_SET_ALL = "MENU_SET_ALL";

export const SET_BS_UNIT = "SET_BS_UNIT";
export const SET_APP_ALL = "SET_APP_ALL";
export const SET_APP_SETINFO = "SET_APP_SETINFO";
export const SET_APP_SHARHSPLIST = "SET_APP_SHARHSPLIST";

export const SET_DEVICE_CONNECT = "SET_DEVICE_CONNECT";
export const SET_SOCKETCOMMAND = "SET_SOCKETCOMMAND";

export const SET_USER_HEALTH = "SET_USER_HEALTH";
export const SET_PAGE_STATE = "SET_PAGE_STATE";

export const SET_SUBMIT_DATA_SIZE = "SET_SUBMIT_DATA_SIZE";
export const SET_DEVICE_BP_LIST = "SET_DEVICE_BP_LIST";
export const SET_DEVICE_BS_LIST = "SET_DEVICE_BS_LIST";

export const SET_MENU_NEW_REPORT_LIST = "SET_MENU_NEW_REPORT_LIST";

export const SET_PRSC_LIST = "SET_PRSC_LIST";
export const SET_ACNT_MRGE_LAYER = "SET_ACNT_MRGE_LAYER";

export const SET_NFTF_DOCTOR = "SET_NFTF_DOCTOR";
export const SET_ITEMSTATE = "SET_ITEMSTATE";
export const SET_NFTF_STATE = "SET_NFTF_STATE";
export const SET_IDCARD_STATE = "SET_IDCARD_STATE";

export const loginRequestAction = data => ({
  type: LOG_IN_REQUEST,
  data,
});

export const logoutRequestAction = () => ({
  type: LOG_OUT_REQUEST,
});

const reducer = (state, action) => {
  switch (action.type) {
    case LOG_IN_SUCCESS: {
      const phonecfg = { ...state.phonecfg };
      const userinfo = action.data;
      let maxAge = -1;
      if (action.isAutoLogin !== undefined) {
        setCookie("isAutologin", action.isAutoLogin, 365);
        setCookieWs({
          isAutologin: action.isAutoLogin,
          loginInfo: action.data,
        });
        if (action.isAutoLogin === true) maxAge = 365;
      } else if (getCookie("isAutologin")) maxAge = 365;
      setCookies(action.data, maxAge);

      setCookieWs({ isAutologin: action.isAutoLogin, loginInfo: action.data });
      setAuth(maxAge);
      if (phonecfg.phoneToken !== "123") {
        setCookie("phoneToken", phonecfg.phoneToken, 365);
      } else {
        let phone = getCookie("phoneToken");
        if (phone !== undefined && phone.length > 0)
          phonecfg.phoneToken = phone;
        else {
          openAlertPopup("앱을 재시작해 주십시요");
        }
      }
      userinfo.phoneToken = phonecfg.phoneToken;
      userinfo.userLat = phonecfg.userLat;
      userinfo.userLng = phonecfg.userLng;
      return { ...state, auth: true, phonecfg: phonecfg, userinfo: userinfo };
    }
    case SET_PHONETOKEN: {
      const phonecfg = { ...state.phonecfg };
      const userinfo = { ...state.userinfo }; // 향후 수정
      phonecfg.phoneToken = action.phoneToken;
      userinfo.phoneToken = action.phoneToken; // 향후 수정
      return { ...state, phonecfg: phonecfg, userinfo: userinfo };
    }
    case SET_GPSINFO: {
      const userinfo = { ...state.userinfo }; // 향후 수정
      const phonecfg = { ...state.phonecfg };
      console.log("data:: ", action, action.userLat, action.userLng);
      userinfo.userLat = action.userLat; // 향후 수정
      userinfo.userLng = action.userLng; // 향후 수정
      phonecfg.userLat = action.userLat;
      phonecfg.userLng = action.userLng;

      return { ...state, userinfo: userinfo, phonecfg: phonecfg };
    }
    case SET_GPSINFO2: {
      const userinfo = { ...state.userinfo }; // 향후 수정
      const phonecfg = { ...state.phonecfg };
      console.log("data:: ", action, action.data.userLat, action.data.userLng);
      userinfo.userLat = action.data.userLat; // 향후 수정
      userinfo.userLng = action.data.userLng; // 향후 수정
      phonecfg.userLat = action.data.userLat;
      phonecfg.userLng = action.data.userLng;

      return { ...state, userinfo: userinfo, phonecfg: phonecfg };
    }
    case LOG_IN_FAILURE: {
      // draft.logInLoading = false;
      // draft.logInError = action.error;
      return { ...state, auth: false };
    }
    case LOG_OUT_REQUEST: {
      // draft.logOutLoading = true;
      // draft.logOutError = null;
      // draft.logOutDone = false;
      return { ...state, auth: false };
    }
    case LOG_OUT_SUCCESS: {
      // draft.logOutLoading = false;
      // draft.logOutDone = true;
      // draft.me = null;
      // setCookies('[]', -1);
      setCookie("isAutologin", false, 0);
      setCookie("isAuthOk", false, 0);
      allDelCookies();
      clearAuth();
      return {
        ...state,
        auth: false,
        userinfo: "",
        mypagecfg: "",
        prscList: [],
        acntMergeLayer: true,
      }; // APP 연동 후  userinfo : null
    }
    case LOG_OUT_FAILURE: {
      // draft.logOutLoading = false;
      // draft.logOutError = action.error;
      return { ...state };
    }
    case SIGN_UP_REQUEST: {
      // draft.signUpLoading = true;
      // draft.signUpError = null;
      // draft.signUpDone = false;
      return { ...state };
    }
    case SIGN_UP_SUCCESS: {
      // draft.signUpLoading = false;
      // draft.signUpDone = true;
      return { ...state };
    }

    case SIGN_UP_FAILURE: {
      // draft.signUpLoading = false;
      // draft.signUpError = action.error;
      return { ...state };
    }

    case SET_BS_UNIT: {
      const userinfo = { ...state.userinfo };
      userinfo.app = { ...userinfo.app };
      userinfo.app.setInfo = { ...userinfo.app.setInfo };
      userinfo.app.setInfo.bsUnit = action.data;
      return { ...state, userinfo: userinfo };
    }

    case SET_APP_ALL: {
      const userinfo = { ...state.userinfo };
      userinfo.app = { ...userinfo.app };
      userinfo.app = action.data;
      return { ...state, userinfo: userinfo };
    }

    case SET_APP_SETINFO: {
      const userinfo = { ...state.userinfo };
      userinfo.app = { ...userinfo.app };
      userinfo.app.setInfo = { ...userinfo.app.setInfo };
      switch (action.key) {
        case "dataAprchYn": // 데이터접근권한
          userinfo.app.setInfo.dataAprchYn = action.data;
          break;
        case "psnlDnYn": // 개인데이터다운로드
          userinfo.app.setInfo.psnlDnYn = action.data;
          break;
        case "psnlDataSharYn": //개인데이터공유
          userinfo.app.setInfo.psnlDataSharYn = action.data;
          break;
        case "inpryAlrmYn": //문진알람
          userinfo.app.setInfo.inpryAlrmYn = action.data;
          break;
        case "hsptResrvAlrmYn": //병원예약알람
          userinfo.app.setInfo.hsptResrvAlrmYn = action.data;
          break;
        case "prsctAlrmYn": //전자처방전알람
          userinfo.app.setInfo.prsctAlrmYn = action.data;
          break;
        case "profAlrmYn": //제증명서류/보험청구알람
          userinfo.app.setInfo.profAlrmYn = action.data;
          break;
        case "chkSchdlAlrmYn": //검사스케줄알람
          userinfo.app.setInfo.chkSchdlAlrmYn = action.data;
          break;
        case "mdcnAlrmYn": //복약알람
          userinfo.app.setInfo.mdcnAlrmYn = action.data;
          break;
        case "psnlHlthAlrmYn": //자가건강관리알람
          userinfo.app.setInfo.psnlHlthAlrmYn = action.data;
          break;
        case "psnlTrmtHistAlrmYn": //개인진료기록알람
          userinfo.app.setInfo.psnlTrmtHistAlrmYn = action.data;
          break;
        case "telResrvAlrmYn": //전화예약진료알람
          userinfo.app.setInfo.telResrvAlrmYn = action.data;
          break;
        case "mrktPushYn": //마케팅정보앱푸쉬
          userinfo.app.setInfo.mrktPushYn = action.data;
          break;
        case "mrktSMSYn": //마케팅정보SMS
          userinfo.app.setInfo.mrktSMSYn = action.data;
          break;
        case "mrktEmailYn": //마케팅정보이메일
          userinfo.app.setInfo.mrktEmailYn = action.data;
          break;
        case "psnlInfoAgreeYn": //개인정보제3자제공
          userinfo.app.setInfo.psnlInfoAgreeYn = action.data;
          break;
      }
      return { ...state, userinfo: userinfo };
    }

    case SET_APP_SHARHSPLIST: {
      const userinfo = { ...state.userinfo };
      userinfo.app = { ...userinfo.app };
      userinfo.app.sharHsptList = [...userinfo.app.sharHsptList];

      userinfo.app.sharHsptList.forEach((element, i) => {
        if (element.hpKey === action.key)
          userinfo.app.sharHsptList[i].sharYn = action.data;
      });
      return { ...state, userinfo: userinfo };
    }

    case SET_PHONE_ALL: {
      let phoneToken = getCookie("phoneToken");
      if (phoneToken && phoneToken !== action.data.phoneToken)
        console.log("SET_PHONE_ALL ", action.data);
      return { ...state, phonecfg: action.data };
    }

    case MAIN_MENU_SET: {
      const mypagecfg = { ...state.mypagecfg };
      mypagecfg.main = { ...mypagecfg.main };
      action.screen.forEach((element, i) => {
        switch (element) {
          case "myHospitalList":
            mypagecfg.main.myHospitalList.cardYn = action.status[i];
            break;
          case "BloodPressure":
            mypagecfg.main.BloodPressure.cardYn = action.status[i];
            break;
          case "ReservationList":
            mypagecfg.main.ReservationList.cardYn = action.status[i];
            break;
        }
      });
      let maxAge = -1;
      if (getCookie("isAutologin")) maxAge = 365;
      // setCookies(mypagecfg, maxAge);

      return { ...state, mypagecfg };
    }

    case MAIN_MENU_ALL_SET: {
      const mypagecfg = { ...state.mypagecfg };
      mypagecfg.main = action.data;
      return { ...state, mypagecfg };
    }

    case SELFCAED_MENU_ALL_SET: {
      const mypagecfg = { ...state.mypagecfg };
      mypagecfg.selfcard = action.data;
      return { ...state, mypagecfg };
    }

    case SELFCAED_MENU_SET: {
      const mypagecfg = { ...state.mypagecfg };
      mypagecfg.selfcard = { ...mypagecfg.selfcard };
      action.screen.forEach((element, i) => {
        switch (element) {
          case "BS":
            mypagecfg.selfcard.BS.cardYn = action.status[i];
            break;
          case "BP":
            mypagecfg.selfcard.BP.cardYn = action.status[i];
            break;
          case "HISTORY":
            mypagecfg.selfcard.HISTORY.cardYn = action.status[i];
            break;
          case "BMI":
            mypagecfg.selfcard.BMI.cardYn = action.status[i];
            break;
          case "ACTIVE":
            mypagecfg.selfcard.ACTIVE.cardYn = action.status[i];
            break;
          case "FOOD":
            mypagecfg.selfcard.FOOD.cardYn = action.status[i];
            break;
          case "ALLERGY":
            mypagecfg.selfcard.ALLERGY.cardYn = action.status[i];
            break;
          case "STUDYRESULT":
            mypagecfg.selfcard.STUDYRESULT.cardYn = action.status[i];
            break;
        }
      });
      let maxAge = -1;
      if (getCookie("isAutologin")) maxAge = 365;
      // setCookies(mypagecfg, maxAge);

      return { ...state, mypagecfg };
    }

    case MENU_SET_ALL: {
      const mypagecfg = { ...state.mypagecfg };
      mypagecfg.main = { ...mypagecfg.main };
      mypagecfg.selfcard = { ...mypagecfg.selfcard };
      // 좀더 줄일수 있는 방법 찾을 것 DSRYU
      const main = action.data.filter(v => {
        return v.cardType === "main";
      });
      const selfcard = action.data.filter(v => {
        return v.cardType === "selfcard";
      });
      let maxAge = -1;
      if (getCookie("isAutologin")) maxAge = 365;
      mypagecfg.main.myHospitalList = Object.assign(
        {},
        ...main.filter(v => {
          return v.cardId === "myHospitalList";
        })
      );
      mypagecfg.main.BloodPressure = Object.assign(
        {},
        ...main.filter(v => {
          return v.cardId === "BloodPressure";
        })
      );
      mypagecfg.main.ReservationList = Object.assign(
        {},
        ...main.filter(v => {
          return v.cardId === "ReservationList";
        })
      );
      mypagecfg.selfcard.BP = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "BP";
        })
      );
      mypagecfg.selfcard.BS = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "BS";
        })
      );
      mypagecfg.selfcard.BMI = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "BMI";
        })
      );
      mypagecfg.selfcard.FOOD = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "FOOD";
        })
      );
      mypagecfg.selfcard.HISTORY = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "HISTORY";
        })
      );
      mypagecfg.selfcard.ACTIVE = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "ACTIVE";
        })
      );
      mypagecfg.selfcard.ALLERGY = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "ALLERGY";
        })
      );
      mypagecfg.selfcard.STUDYRESULT = Object.assign(
        {},
        ...selfcard.filter(v => {
          return v.cardId === "STUDYRESULT";
        })
      );
      // setCookies(mypagecfg, maxAge);
      return { ...state, mypagecfg: mypagecfg };
    }

    case SET_DEVICE_CONNECT:
      return { ...state, deviceCfg: action.data };

    case SET_SOCKETCOMMAND:
      return { ...state, deviceCfg: action.data };

    case SET_USER_HEALTH:
      const userHlthInfo = action.data;

      let maxAge = -1;

      if (getCookie("isAutologin")) {
        maxAge = 365;
      }

      // setCookies(userHlthInfo, maxAge);

      return { ...state, userHlthInfo: userHlthInfo };

    // case SET_UPLOAD_INFO:
    //     // const uploadInfo = action.data;

    //     return {...state, uploadInfo : action.data}

    case SET_PAGE_STATE:
      const pageState = { ...state.pageState };

      if (action.data.type == "share") {
        pageState.share = action.data.state;
      } else if (action.data.type == "reload") {
        pageState.reload = action.data.state;
      } else {
        pageState.share = 0;
        pageState.reload = 0;
      }

      return { ...state, pageState: pageState };

    case SET_SUBMIT_DATA_SIZE:
      const appStdInfo = action.data;
      return { ...state, appStdInfo: appStdInfo };

    case SET_DEVICE_BP_LIST:
      const deviceBpList = action.data;
      return { ...state, dvcBpInfo: deviceBpList };

    case SET_DEVICE_BS_LIST:
      const deviceBsList = action.data;
      return { ...state, dvcBsInfo: deviceBsList };

    case SET_MENU_NEW_REPORT_LIST:
      const menuNewInfo = action.data;
      return { ...state, menuNewInfo: menuNewInfo };

    // 처방전 리스트 저장
    case SET_PRSC_LIST:
      const prscList = action.data;
      return { ...state, prscList: prscList };

    case SET_ACNT_MRGE_LAYER:
      const acntMergeLayer = action.data;
      return { ...state, acntMergeLayer: acntMergeLayer };

    case SET_NFTF_DOCTOR:
      return { ...state, nftfDoctor: action.data };

    case SET_ITEMSTATE:
      const itemState = { ...itemState };
      if (action.data.type === "SET") {
        itemState.data = action.data.data;
        itemState.reload = true;
      } else {
        itemState.reload = false;
      }
      return { ...state, itemState: itemState };

    case SET_NFTF_STATE:
      const nftfState = { ...nftfState };
      if (action.data.type === "SET") {
        nftfState.data = action.data;
        nftfState.reload = true;
      } else {
        nftfState.reload = false;
      }
      return { ...state, nftfState: nftfState };

    case SET_IDCARD_STATE:
      const idCardState = { ...idCardState };
      if (action.data.type === "SET") {
        idCardState.data = action.data.data;
        idCardState.reload = true;
      } else {
        idCardState.reload = false;
      }

      return { ...state, idCardState: idCardState };
  }
};

const AppProvider = ({ children, deviceCfg }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    auth,
    userinfo,
    cfg,
    mypagecfg,
    phonecfg,
    pageState,
    appStdInfo,
    dvcBpInfo,
    dvcBsInfo,
    menuNewInfo,
    prscList,
    acntMergeLayer,
    nftfDoctor,
    itemState,
    nftfState,
    idCardState,
  } = state;

  const value = useMemo(
    () => ({
      auth,
      userinfo,
      cfg,
      mypagecfg,
      phonecfg,
      dispatch,
      deviceCfg,
      pageState,
      appStdInfo,
      dvcBpInfo,
      dvcBsInfo,
      menuNewInfo,
      prscList,
      acntMergeLayer,
      nftfDoctor,
      itemState,
      nftfState,
      idCardState,
    }),
    [
      mypagecfg.main,
      userinfo,
      phonecfg,
      deviceCfg,
      pageState,
      appStdInfo,
      dvcBpInfo,
      dvcBsInfo,
      menuNewInfo,
      prscList,
      acntMergeLayer,
      nftfDoctor,
      itemState,
      nftfState,
      idCardState,
    ]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

const handleOnMessage = (dispatch, deviceCfg, evt) => {
  let response;
  const deviceList = deviceCfg;
  if (evt.data.toString().substring(0, 1) == "{") {
    response = JSON.parse(evt.data);
    callback2Handle && callback2Handle(undefined, undefined, "{", true);
  } else {
    response = evt.data;
    callback2Handle && callback2Handle(undefined, undefined, "!{", true);
  }

  callback2Handle && callback2Handle(undefined, undefined, evt.data, true);

  // response.data.phoneToken = "";
  callback2Handle &&
    callback2Handle(
      undefined,
      undefined,
      `handleOnMessage response.command: ${response?.command ?? "null"}`,
      true
    );

  try {
    if (response.command !== undefined) {
      // if(JSON.parse(response.command).command) {
      if (response.command.substring(0, 1) == "{") {
        switch (JSON.parse(response.command).command) {
          case SocketCommand.GET_PHONE_INFO.command:
            callback2Handle &&
              callback2Handle(
                undefined,
                undefined,
                "response.data.userLat = " + response.data.userLat,
                true
              );
            callback2Handle &&
              callback2Handle(
                undefined,
                undefined,
                "response.data.userLng = " + response.data.userLng,
                true
              );
            callback2Handle &&
              callback2Handle(
                undefined,
                undefined,
                "response.data.phoneOS = " + response.data.phoneOS,
                true
              );
            callback2Handle &&
              callback2Handle(
                undefined,
                undefined,
                "response.data.version = " + response.data.version,
                true
              );
            callback2Handle &&
              callback2Handle(
                undefined,
                undefined,
                "response.data.phoneToken = " + response.data.phoneToken,
                true
              );
            if (
              response.data.phoneToken !== undefined &&
              response.data.userLat !== undefined &&
              response.data.userLng !== undefined &&
              response.data.phoneOS !== undefined &&
              response.data.version !== undefined
            ) {
              if (callbackHandle !== undefined) {
                callbackHandle({ type: SET_PHONE_ALL, data: response.data });
              } else {
                if (
                  !response.data.phoneToken ||
                  response.data.phoneToken === ""
                ) {
                  webSocket.close();
                  callback2Handle &&
                    callback2Handle(
                      1,
                      true,
                      `phoneToken: ${response.data.phoneToken}`
                    );
                  return;
                }
                setCookies(response.data, 365);
                setCookie("phoneCfg", response.data, 365);
                callback2Handle && callback2Handle(999, false, "999");
                dispatch({ type: SET_PHONE_ALL, data: response.data });
              }
            } else if (!response.data.phoneToken) {
              callback2Handle &&
                callback2Handle(1, true, "!response.data.phoneToken");
            } else {
              switch (response.command) {
                case SocketCommand.GET_GPS_INFO_RES:
                  if (response.data.userLat && response.data.userLng) {
                    dispatch({ type: SET_GPSINFO, data: response.data });
                  } else {
                    console.log("response.data value is undefined...");
                  }
                  break;

                case SocketCommand.WEB_VIEW_OPEN_RES:
                  if (response.data.isResult != 200) {
                    // alert("통신오류");
                  }
                  break;

                case SocketCommand.MD_EDUCO_CONNECT_RES:
                  if (response.data.isResult === 200) {
                    callbackHandle();
                  }

                  if (response.data.isResult != 200) {
                    alert("웹소켓 연결 실패 : " + response.data.isResult);
                  }
                  break;

                case SocketCommand.GET_BT_STATUS_RES:
                  deviceList.deviceTypes = response.data;
                  dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                  break;
                // evt.data = {"command":"1000","data":{"isPaired":true}}
                case SocketCommand.BP170B_REGISTER_RES:
                  if (response.data.isResult === 200) {
                    let deviceSeq;

                    if (putData.modelName === "Omron") {
                      deviceSeq = 1;
                    } else {
                      deviceSeq = 0;
                    }

                    deviceList.deviceTypes[0].devices[
                      deviceSeq
                    ].isConnected = true;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                    // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
                    if (callbackHandle !== undefined)
                      callbackHandle(true, false);
                  } else {
                    if (callbackHandle !== undefined) {
                      callbackHandle(false, false);
                    }
                  }
                  break;

                case SocketCommand.BP170B_REMOVE_RES:
                  if (response.data.isResult === 200) {
                    let deviceSeq;

                    if (putData.modelName === "Omron") {
                      deviceSeq = 1;
                    } else {
                      deviceSeq = 0;
                    }

                    deviceList.deviceTypes[0].devices[
                      deviceSeq
                    ].isConnected = false;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                    // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
                    if (callbackHandle !== undefined)
                      callbackHandle(false, false);
                  }
                  break;

                case SocketCommand.BP_MEASURE_DATA_RES:
                  // 필요한 데이타 있으면 요청
                  if (response.data.isResult === 200) {
                    callbackHandle(response.data);
                  }

                  break;

                case SocketCommand.BP_CONNECT_RES:
                  if (response.data.isResult === 200) {
                    callbackHandle(response);
                  }
                  break;

                case SocketCommand.BP_AUTOINPUT_STAUS_RES:
                  console.log("BP_AUTOINPUT_STAUS_RES: ", response);

                  if (response.data[0].isResult === 200) {
                    if (deviceList.deviceTypes[0].autoLogin === true) {
                      callbackHandle("A");
                      deviceList.deviceTypes[0].autoLogin = false;
                    } else {
                      callbackHandle("M");
                      deviceList.deviceTypes[0].autoLogin = true;
                    }

                    // deviceList.deviceTypes[0].autoLogin = response.data[0].autoInput;
                    // deviceList.deviceTypes[0].autoLogin = true;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });
                  } else {
                    console.log("BP_AUTOINPUT_STAUS FAIL: ", response);
                  }

                  break;

                case SocketCommand.BS_ACCUCHECK_REGISTER_RES:
                  console.log("### response.data", response.data);
                  if (response.data.isResult === 200) {
                    deviceList.deviceTypes[1].devices[0].isConnected = true;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                    // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
                    if (callbackHandle !== undefined)
                      callbackHandle(true, false);
                  } else {
                    if (callbackHandle !== undefined)
                      callbackHandle(false, false);
                  }
                  break;

                case SocketCommand.BS_ACCUCHECK_REMOVE_RES:
                  console.log("### response.data", response.data);
                  if (response.data.isResult === 200) {
                    deviceList.deviceTypes[1].devices[0].isConnected = false;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                    // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
                    if (callbackHandle !== undefined)
                      callbackHandle(false, false);
                  }
                  break;

                case SocketCommand.F62E_B_REGISTER_RES:
                  if (response.data.isResult === 200) {
                    // const deviceList = deviceCfg
                    deviceList.deviceTypes[2].devices[0].isConnected = true;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                    // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
                    if (callbackHandle !== undefined)
                      callbackHandle(true, false);
                  } else {
                    if (callbackHandle !== undefined)
                      callbackHandle(false, false);
                  }
                  break;

                case SocketCommand.F62E_B_REMOVE_RES:
                  if (response.data.isResult === 200) {
                    deviceList.deviceTypes[2].devices[0].isConnected = false;
                    dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

                    // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
                    if (callbackHandle !== undefined)
                      callbackHandle(false, false);
                  }
                  break;

                case SocketCommand.F62E_B_MEASURE_DATA_RES:
                  if (response.data.isResult === 200) {
                    callbackHandle(response.data);
                  }
                  break;

                case SocketCommand.ETC_VIEW_OPEN_RES:
                  if (response.data.isResult === 200) {
                    callbackHandle(response.data);
                  }
                  break;

                case SocketCommand.COMMON_FILE_DOWNLOAD_RES:
                  console.log(
                    "response.data.isResult :: ",
                    response.data.isResult
                  );
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      // closeLoadingLayer();
                      callbackHandle();
                    }, 1000);
                  } else {
                    alert("다운로드 실패");
                  }
                  break;

                case SocketCommand.MULTI_FILE_DOWNLOAD_RES:
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      closeLoadingLayer();
                      callbackHandle();
                    }, 1000);
                  }
                  break;

                case SocketCommand.FILE_UPLOAD_RES:
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      if (response.data.resData.type === "upload") {
                        dispatch({
                          type: SET_PAGE_STATE,
                          data: { type: "share", state: 0 },
                        });
                      } else {
                        if (response.data.resData.redirectURL === "") {
                          dispatch({
                            type: SET_PAGE_STATE,
                            data: { type: "reload", state: 1 },
                          });
                        } else {
                          _O.Open("/" + response.data.resData.redirectURL);
                        }
                      }
                    }, 1000);
                  }
                  break;

                case SocketCommand.PROGRESS_RES:
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      callbackHandle(response.data.isResult);
                    }, 1000);
                  }
                  break;

                case SocketCommand.COMMON_FILE_VIEW_RES:
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      callbackHandle();
                    }, 1000);
                  }
                  break;

                case SocketCommand.PRSC_DNLD_RES:
                  if (response.data.isResult === 200) {
                    closeLoadingLayer();
                    setTimeout(() => {
                      callbackHandle();

                      if (response.data.reserved != "") {
                        _O.Open(response.data.reserved);
                      }
                    }, 1000);
                  } else {
                    closeLoadingLayer();
                    setTimeout(() => {
                      callbackHandle();
                    }, 1000);
                  }
                  break;

                case SocketCommand.PRSC_DNLD_MULTI_RES:
                  if (response.data.isResult === 200) {
                    closeLoadingLayer();
                    setTimeout(() => {
                      // callbackHandle();

                      if (response.data.reserved != "") {
                        _O.Open(response.data.reserved);
                      }
                    }, 1000);
                  } else {
                    closeLoadingLayer();
                    setTimeout(() => {
                      callbackHandle();
                    }, 1000);
                  }
                  break;

                case SocketCommand.ADD_PAPER_RES:
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      callbackHandle();
                    }, 1000);
                  }
                  break;

                case SocketCommand.MULTI_FILE_DOWNLOAD_RES:
                  if (response.data.isResult === 200) {
                    setTimeout(() => {
                      callbackHandle();
                    }, 1000);
                  }
                  break;

                case SocketCommand.LOGIN_APPLE_RES:
                  if (response.data.isResult === 200) {
                    if (response.data.userID) {
                      setTimeout(() => {
                        callbackHandle(
                          response.data.userEmail,
                          response.data.userName,
                          response.data.userID,
                          "600"
                        );
                      }, 1000);
                    }
                  }
                  break;

                case SocketCommand.SET_COOKIE_RES:
                  console.log(
                    "response.data.isResult :: ",
                    response.data.isResult
                  );
                  if (response.data.isResult === 200) {
                    if (callbackHandle != undefined) {
                      setTimeout(() => {
                        console.log("response.data :: ", response.data);
                        callbackHandle(response.data);
                      }, 200);
                    }
                  } else {
                    if (callbackHandle != undefined) {
                      setTimeout(() => {
                        callbackHandle(response.data);
                      }, 200);
                    }
                  }
                  break;

                default:
                  console.log("NOT support command: " + response.command);
                  break;
              }
            }
            break;

          case SocketCommand.GET_BT_STATUS_RES.command:
            deviceList.deviceTypes = response.data;
            dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

            break;
          case SocketCommand.BP170B_REGISTER_RES.command:
            console.log("response.data.isResult====", response.data.isResult);
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[0].devices[0].isConnected = true;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(true, false);
            } else {
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.BP170B_REMOVE_RES.command:
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[0].devices[0].isConnected = false;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.BP_MEASURE_DATA_RES.command:
            // 필요한 데이타 있으면 요청
            console.log(
              "### SocketCommand.BP_MEASURE_DATA received: ",
              response
            );
            callbackHandle(response.data);

            break;

          case SocketCommand.BP_CONNECT_RES.command:
            console.log("SocketCommand.BP_CONNECT received: ", response);
            callbackHandle(response);

            break;

          case SocketCommand.BP_AUTOINPUT_STAUS_RES.command:
            if (response.data[0].isResult === 200) {
              if (deviceList.deviceTypes[0].autoLogin === true) {
                callbackHandle("A");
                deviceList.deviceTypes[0].autoLogin = false;
              } else {
                callbackHandle("M");
                deviceList.deviceTypes[0].autoLogin = true;
              }
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });
            } else {
              console.log("BP_AUTOINPUT_STAUS FAIL: ", response);
            }

            break;

          case SocketCommand.BS_ACCUCHECK_REGISTER_RES.command:
            console.log("### response.data", response.data);
            if (response.data.isResult == 200) {
              deviceList.deviceTypes[1].devices[0].isConnected = true;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(true, false);
            } else {
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.BS_ACCUCHECK_REMOVE_RES.command:
            console.log("### response.data", response.data);
            if (response.data.isResult == 200) {
              deviceList.deviceTypes[1].devices[0].isConnected = false;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(false, false);
              $(".btn-connect").html("<i></i>연결");
              $(".btn-connect").css("background", "#7fd2c2");
            }
            break;

          case SocketCommand.F62E_B_REGISTER_RES.command:
            if (response.data.isResult == 200) {
              // const deviceList = deviceCfg
              deviceList.deviceTypes[2].devices[0].isConnected = true;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(true, false);
            } else {
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.F62E_B_REMOVE_RES.command:
            if (response.data.isResult == 200) {
              deviceList.deviceTypes[2].devices[0].isConnected = false;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.F62E_B_MEASURE_DATA_RES.command:
            callbackHandle(response.data);
            break;
          default:
            console.log("NOT support command: " + response.command);

            break;
        }
      } else {
        switch (response.command) {
          case SocketCommand.GET_PHONE_INFO.command:
            if (
              response.data.phoneTo == undefined &&
              response.data.userLat !== undefined &&
              response.data.userLng !== undefined &&
              response.data.phoneOS !== undefined &&
              response.data.version !== undefined &&
              response.data.phoneToken !== ""
            ) {
              if (callbackHandle !== undefined) {
                callbackHandle({ type: SET_PHONE_ALL, data: response.data });
              } else {
                if (
                  !response.data.phoneToken ||
                  response.data.phoneToken === ""
                ) {
                  webSocket.close();
                  callback2Handle &&
                    callback2Handle(
                      1,
                      true,
                      `phoneToken: ${response.data.phoneToken}`
                    );
                  return;
                }
                setCookies(response.data, 1);
                setCookie("phoneCfg", response.data, 1);
                callback2Handle && callback2Handle(999, false, 999);
                dispatch({ type: SET_PHONE_ALL, data: response.data });
              }
            } else {
              console.log("response.data value is undefined...");
              callback2Handle &&
                callback2Handle(
                  1,
                  true,
                  "response.data value is undefined... or phoneToken is ''"
                );
            }
            break;

          case SocketCommand.GET_GPS_INFO_RES:
            if (response.data.userLat && response.data.userLng) {
              dispatch({ type: SET_GPSINFO, data: response.data });
            } else {
              console.log("response.data value is undefined...");
            }
            break;

          case SocketCommand.WEB_VIEW_OPEN_RES:
            if (response.data.isResult != 200) {
              // alert("통신오류");
            }
            break;

          case SocketCommand.MD_EDUCO_CONNECT_RES:
            if (response.data.isResult === 200) {
              callbackHandle();
            }

            if (response.data.isResult != 200) {
              alert("웹소켓 연결 실패 : " + response.data.isResult);
            }
            break;

          case SocketCommand.GET_BT_STATUS_RES:
            deviceList.deviceTypes = response.data;
            dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

            break;
          // evt.data = {"command":"1000","data":{"isPaired":true}}
          case SocketCommand.BP170B_REGISTER_RES:
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[0].devices[0].isConnected = true;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(true, false);
            } else {
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.BP170B_REMOVE_RES:
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[0].devices[0].isConnected = false;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.BP_MEASURE_DATA_RES:
            // 필요한 데이타 있으면 요청
            if (response.data.isResult === 200) {
              callbackHandle(response.data);
            }

            break;

          case SocketCommand.BP_CONNECT_RES:
            if (response.data.isResult === 200) {
              callbackHandle(response);
            }
            break;

          case SocketCommand.BP_AUTOINPUT_STAUS_RES:
            console.log("BP_AUTOINPUT_STAUS_RES: ", response);

            if (response.data[0].isResult === 200) {
              if (deviceList.deviceTypes[0].autoLogin === true) {
                callbackHandle("A");
                deviceList.deviceTypes[0].autoLogin = false;
              } else {
                callbackHandle("M");
                deviceList.deviceTypes[0].autoLogin = true;
              }
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });
            } else {
              console.log("BP_AUTOINPUT_STAUS FAIL: ", response);
            }

            break;

          case SocketCommand.BS_ACCUCHECK_REGISTER_RES:
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[1].devices[0].isConnected = true;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(true, false);
            } else {
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.BS_ACCUCHECK_REMOVE_RES:
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[1].devices[0].isConnected = false;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.F62E_B_REGISTER_RES:
            if (response.data.isResult === 200) {
              // const deviceList = deviceCfg
              deviceList.deviceTypes[2].devices[0].isConnected = true;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(true, false);
            } else {
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.F62E_B_REMOVE_RES:
            if (response.data.isResult === 200) {
              deviceList.deviceTypes[2].devices[0].isConnected = false;
              dispatch({ type: SET_DEVICE_CONNECT, data: deviceList });

              // 디바이스 연결 화면에서 화면 갱신 안되서 callback으로 처리
              if (callbackHandle !== undefined) callbackHandle(false, false);
            }
            break;

          case SocketCommand.F62E_B_MEASURE_DATA_RES:
            if (response.data.isResult === 200) {
              callbackHandle(response.data);
            }
            break;

          case SocketCommand.COMMON_FILE_DOWNLOAD_RES:
            if (response.data.isResult === 200) {
              setTimeout(() => {
                // closeLoadingLayer();
                callbackHandle();
              }, 1000);
            } else {
              alert("다운로드 실패");
            }
            break;

          case SocketCommand.MULTI_FILE_DOWNLOAD_RES:
            if (response.data.isResult === 200) {
              setTimeout(() => {
                closeLoadingLayer();
                callbackHandle();
              }, 1000);
            }
            break;

          case SocketCommand.FILE_UPLOAD_RES:
            // response.data.type : upload, download
            // type이 download인 경우
            // response.data.isResult == 200 && redirectURL == "" 리스트갱신
            // response.data.isResult == 200 && redirectURL != "" 페이지 이동
            // type이 upload인 경우 response.data.isResult == 200 -> 공유모드 해제
            if (response.data.isResult === 200) {
              setTimeout(() => {
                if (response.data.resData.type === "upload") {
                  dispatch({
                    type: SET_PAGE_STATE,
                    data: { type: "share", state: 0 },
                  });
                } else {
                  if (response.data.resData.redirectURL === "") {
                    dispatch({
                      type: SET_PAGE_STATE,
                      data: { type: "reload", state: 1 },
                    });
                  } else {
                    _O.Open("/" + response.data.resData.redirectURL);
                  }
                }
              }, 1000);
            }
            break;

          case SocketCommand.PROGRESS_RES:
            if (response.data.isResult === 200) {
              setTimeout(() => {
                callbackHandle(response.data.isResult);
              }, 1000);
            }
            break;

          case SocketCommand.COMMON_FILE_VIEW_RES:
            if (response.data.isResult === 200) {
              setTimeout(() => {
                callbackHandle();
              }, 1000);
            }
            break;

          case SocketCommand.PRSC_DNLD_RES:
            if (response.data.isResult === 200) {
              closeLoadingLayer();
              setTimeout(() => {
                callbackHandle();

                if (response.data.reserved != "") {
                  _O.Open(response.data.reserved);
                }
              }, 1000);
            } else {
              closeLoadingLayer();
              setTimeout(() => {
                callbackHandle();
              }, 1000);
            }
            break;

          case SocketCommand.PRSC_DNLD_MULTI_RES:
            if (response.data.isResult === 200) {
              closeLoadingLayer();
              setTimeout(() => {
                // callbackHandle();

                if (response.data.reserved != "") {
                  _O.Open(response.data.reserved);
                }
              }, 1000);
            } else {
              closeLoadingLayer();
              setTimeout(() => {
                callbackHandle();
              }, 1000);
            }
            break;

          case SocketCommand.ADD_PAPER_RES:
            if (response.data.isResult === 200) {
              setTimeout(() => {
                callbackHandle();
              }, 1000);
            }
            break;

          case SocketCommand.MULTI_FILE_DOWNLOAD_RES:
            if (response.data.isResult === 200) {
              setTimeout(() => {
                callbackHandle();
              }, 1000);
            }
            break;

          case SocketCommand.LOGIN_APPLE_RES:
            if (response.data.isResult === 200) {
              if (response.data.userID) {
                setTimeout(() => {
                  callbackHandle(
                    response.data.userEmail,
                    response.data.userName,
                    response.data.userID,
                    "600"
                  );
                }, 1000);
              }
            }
            break;

          case SocketCommand.SET_COOKIE_RES:
            if (response.data.isResult === 200) {
              if (callbackHandle != undefined) {
                setTimeout(() => {
                  callbackHandle(response.data);
                }, 200);
              }
            }
            break;

          default:
            console.log("NOT support command: " + response.command);
            break;
        }
      }
    } else {
      // GET_PHONE_INFO_OLD 처리
      if (
        response.phoneToken !== undefined &&
        response.userLat !== undefined &&
        response.userLng !== undefined &&
        response.phoneOS !== undefined &&
        response.version !== undefined
      ) {
        console.log("response.phoneToken = " + response.phoneToken);
        console.log("response.userLat = " + response.userLat);
        console.log("response.userLng = " + response.userLng);
        console.log("response.phoneOS = " + response.phoneOS);
        console.log("response.version = " + response.version);

        if (callbackHandle !== undefined) {
          callbackHandle({ type: SET_PHONE_ALL, data: JSON.parse(evt.data) });
        } else {
          setCookie("phoneCfg", JSON.parse(evt.data), 365);
          setCookies(JSON.parse(evt.data), 365);
          dispatch({ type: SET_PHONE_ALL, data: JSON.parse(evt.data) });
        }
      } else {
        console.log("response value is undefined...");
      }
    }
  } catch (e) {
    console.log("err::", e.msg);
    callback2Handle &&
      callback2Handle(undefined, undefined, `catch : ${e.msg}`, true);
    return;
  }
};

export {
  authCfg,
  cfgInProps,
  deviceCfgInProps,
  mypagecfgInProps,
  phonecfgInProps,
  userHlthInfoProps,
  userinfoInProps,
};
export default AppProvider;

